import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { AdminShippingMethodPriceRequest } from './admin-shipping-method-price.request';

@jsonObject
export class AdminShippingMethodUpdateRequest {
  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly category!: string;

  @jsonMember(String)
  public readonly description!: string;

  @jsonArrayMember(AdminShippingMethodPriceRequest)
  public readonly prices!: AdminShippingMethodPriceRequest[];

  public constructor(
    private readonly data: {
      name: string;
      category: string;
      description: string;
      prices: AdminShippingMethodPriceRequest[];
    },
  ) {
    this.name = this.data.name;
    this.category = this.data.category;
    this.description = this.data.description;
    this.prices = this.data.prices;
  }
}
